import { z } from "zod";
export const venusDeepSpaceEvidenceRefSchema = z.string()
    .regex(/^dse_[0-9a-f]{40}$/u);
export const venusDeepSpaceEvidenceRecordSchema = z.object({
    ref: venusDeepSpaceEvidenceRefSchema,
    explorerIndex: z.number().int().min(0).max(7),
    toolCallId: z.string().trim().min(1).max(240),
    toolName: z.string().trim().min(1).max(160),
    payloadSha256: z.string().regex(/^[0-9a-f]{64}$/u),
    arguments: z.unknown(),
    result: z.unknown(),
    observedAt: z.number().int().nonnegative(),
}).strict();
export const storeVenusDeepSpaceEvidenceInputSchema = z.object({
    parentRunId: z.string().trim().min(1).max(200),
    workerId: z.string().trim().min(1).max(200),
    attemptNumber: z.number().int().positive(),
    evidence: venusDeepSpaceEvidenceRecordSchema,
}).strict();
export const readVenusDeepSpaceEvidenceInputSchema = z.object({
    parentRunId: z.string().trim().min(1).max(200),
    workerId: z.string().trim().min(1).max(200),
    attemptNumber: z.number().int().positive(),
    requests: z.array(z.object({
        ref: venusDeepSpaceEvidenceRefSchema,
        offset: z.number().int().nonnegative().default(0),
        maxChars: z.number().int().min(512).max(24_000).default(12_000),
    }).strict()).min(1).max(3),
}).strict();
export const venusDeepSpaceEvidenceChunkSchema = z.object({
    ref: venusDeepSpaceEvidenceRefSchema,
    toolName: z.string().trim().min(1).max(160),
    payloadSha256: z.string().regex(/^[0-9a-f]{64}$/u),
    offset: z.number().int().nonnegative(),
    totalChars: z.number().int().nonnegative(),
    text: z.string(),
    truncated: z.boolean(),
    nextOffset: z.number().int().positive().optional(),
}).strict();
